import request from '@/utils/request';

export function fetchUserInfo() {
  return request({
    url: '/enterprise-server/current-user',
    method: 'get'
  });
}

export function fetchUserAuthList() {
  return request({
    url: '/enterprise-server/current-user-auths',
    method: 'get'
  });
}

export function fetchUserOrgList() {
  return request({
    url: '/enterprise-server/current-user-orgs',
    method: 'get'
  });
}

export function fetchPlatformInfo() {
  return request({
    url: '/enterprise-server/platform',
    method: 'get'
  });
}

export function changePassword(param) {
  return request({
    url: '/enterprise-server/change-password',
    method: 'post',
    data: param
  });
}

// 以下API全部废弃

// 1. admin获取用户列表
export function fetchAdminUserList(params) {
  return request({
    url: '/ajax/system/users',
    method: 'get',
    params: params || {
      page: 1,
      size: 99
    }
  });
}

// 2. admin获取用户信息
export function fetchAdminUserInfo(uid) {
  return request({
    url: '/ajax/system/user/' + uid,
    method: 'get'
  });
}

// 3. admin更新用户信息
export function updateAdminUserInfo(data) {
  return request({
    url: '/ajax/system/user',
    method: 'PUT',
    data: data
  });
}

// 4. admin删除用户
export function deleteAdminUser(userID) {
  return request({
    url: '/ajax/system/user/' + userID,
    method: 'DELETE'
  });
}

// 5. admin新增用户
export function addAdminUser(data) {
  return request({
    url: '/ajax/system/user',
    method: 'post',
    data: data
  });
}

// 1. 获取用户列表
export function fetchUserList(params) {
  return request({
    url: '/ajax/enterprises/' + params.ID + '/users',
    method: 'get',
    params: params || {
      page: 1,
      size: 99
    }
  });
}

// 4. 删除用户
export function deleteUser(params) {
  return request({
    url: '/ajax/enterprises/' + params.ID + '/user',
    method: 'DELETE',
    params: { uid: params.uid }
  });
}

// 5. 新增用户
export function addUser(data) {
  return request({
    url: '/ajax/enterprises/' + data.ID + '/user',
    method: 'post',
    data: data
  });
}
// 获取用户下的所有应用
export function getSelfAppList(params) {
  return request({
    method: 'GET',
    url: `/app-server/markets/${params.marketID}/userapp/${params.userID}`,
    params: {
      page: params.page,
      pageSize: params.pageSize
    }
  });
}
// 获取用户聚合页下的所有应用
export function getSelfSortAppList(params) {
  return request({
    method: 'GET',
    url: `app-server/marketui/${params.marketID}/aggregation/${params.userID}`,
    params: params
  });
}
// 获取应用作者信息
export function getAuthorInfo(params) {
  return request({
    method: 'GET',
    url: `app-server/marketui/${params.marketID}/publisher/${params.userID}`
  });
}




// WEBPACK FOOTER //
// ./src/api/user.js